export default __webpack_public_path__ + "static/media/white-logo.cf307626.png";